import {Cureus} from '../Cureus';

Cureus.EditorialBoard= {};

//= require_tree ./EditorialBoard
